import { getRelativeTime } from "../../../../app/dateHelpers";
import { Icon, IconDefinitions } from "../../../../components";

interface ClientStatusCardProps {
  isOnline: boolean;
  lastSeenDate: string | null;
  companyName: string | null;
  isHeartbeatLoggingOn: boolean;
  runningVersion: string;
}

export function ClientStatusCard({
  isOnline,
  lastSeenDate,
  companyName,
  isHeartbeatLoggingOn,
  runningVersion,
}: ClientStatusCardProps) {
  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body p-4">
        <h5 className="mb-4 d-flex align-items-center">
          <Icon
            iconName={IconDefinitions.chartLine}
            className="me-2 text-primary"
          />
          Device Status
        </h5>

        <div className="row g-4">
          {/* Connection */}
          <div className="col-lg-3">
            <div className="text-center">
              <Icon
                iconName={
                  isOnline
                    ? IconDefinitions.circleCheck
                    : IconDefinitions.circleXmark
                }
                style={{ fontSize: '2rem' }}
                className={isOnline ? 'text-success' : 'text-warning'}
              />
              <div className="text-muted small mt-2 mb-1">Connection Status</div>
              <h5 className="mb-0">{isOnline ? 'Online' : 'Offline'}</h5>
              {lastSeenDate && (
                <small className="text-muted">
                  Last seen {getRelativeTime(new Date(lastSeenDate))}
                </small>
              )}
            </div>
          </div>

          {/* Company */}
          <div className="col-lg-3">
            <div className="text-center">
              <Icon
                iconName={IconDefinitions.company}
                style={{ fontSize: '2rem' }}
                className="text-primary"
              />
              <div className="text-muted small mt-2 mb-1">Company</div>
              <h5 className="mb-0">{companyName || 'Not Assigned'}</h5>
            </div>
          </div>

          {/* Heartbeat */}
          <div className="col-lg-3">
            <div className="text-center">
              <Icon
                iconName={IconDefinitions.heartbeat}
                style={{ fontSize: '2rem' }}
                className={isHeartbeatLoggingOn ? 'text-success' : 'text-secondary'}
              />
              <div className="text-muted small mt-2 mb-1">Heartbeat Logging</div>
              <h5 className="mb-0">
                {isHeartbeatLoggingOn ? 'Enabled' : 'Disabled'}
              </h5>
            </div>
          </div>

          {/* Version */}
          <div className="col-lg-3">
            <div className="text-center">
              <Icon
                iconName={IconDefinitions.code}
                style={{ fontSize: '2rem' }}
                className="text-primary"
              />
              <div className="text-muted small mt-2 mb-1">Client Version</div>
              <h5 className="mb-0">v{runningVersion}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}